import React from "react";
import {BaseSearchableService} from "./Core/BaseSearchableService";
import SpeciesTypeIcon from '../../../monitoring/src/Components/CustomIcons/SpeciesTypeIcon'

class SpeciesService extends BaseSearchableService {
    get Url() { return super.Url + "/species"; }
    get ModelName() { return "Species"; }
    get PrimaryKeyProperty() { return "speciesId"; }
    get TitleProperty() { return "latinName"; }

    GetSubtitle(model) {
        return model ? model.commonName : "";
    }

    GetFullTitle(model) {
        if(!model) {
            return 'a species';
        }
        const title = this.GetTitle(model), subtitle = this.GetSubtitle(model);
        if(title === subtitle) {
            return subtitle;
        }
        return `${subtitle} (${title})`;
    }
    
    GetIcon(model) {
        if(model?.speciesTypeId) {
            return <SpeciesTypeIcon className="species-icon icon" speciesTypeId={model?.speciesTypeId}/>
        }
        return null;
    }

    Get(modelId = null) {
        return this.SendRequest(BaseSearchableService.GET);
    }

    GetSpeciesRequests(modelId = null) {
        return this.SendRequest(BaseSearchableService.POST, null, null, '/requests');
    }

    Search(name, speciesTypeId = null, contextNodeId = null) {
        const request = {name, speciesTypeId, contextNodeId};

        return this.SendRequest(BaseSearchableService.GET, request);
    }

    UpdateSpecies(species) {
        return this.SendRequest(BaseSearchableService.PUT, species);
    }

    CreateSpecies(species) {
        return this.SendRequest(BaseSearchableService.POST, species);
    }
}

export const service = new SpeciesService();

